import React from "react";

interface INameAndEmailProps {
  text: any;
  emailStyle?: React.CSSProperties;
  useNewLine?: boolean;
}

const NameAndEmail = ({
  text,
  emailStyle = {},
  useNewLine = false,
}: INameAndEmailProps) => {
  const parts = text.split(" <");

  if (parts.length < 2) {
    return text;
  }

  const name = parts[0];
  const email = parts[1].replace(">", "");

  return (
    <>
      <span>{name}</span>
      {useNewLine ? <br /> : " "}
      <span style={{ opacity: 0.65, fontWeight: 400, ...emailStyle }}>
        {useNewLine ? email : `<${email}>`}
      </span>
    </>
  );
};

export default NameAndEmail;
